import PropLabelQuizPreview from "./PropLabelQuizPreview";

export default function PropLabelOrderQuizPreview() {
  return <PropLabelQuizPreview ordered />;
}
